import { Locale, type LocalizedString } from "../Locale.js";

export const serviceSparePartsPathMap = {
	[Locale.cs]: "nahradni-dily" as const,
} satisfies LocalizedString;
